import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Activer les notifications WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Appels automatiques pour les commandes en attente',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: "Horaires d'ouverture",
    [ONBOARDING_GUIDE_STEPS.Location]: 'Localisation',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identité du restaurant',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Délai de retrait',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Délai de livraison',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Identifiants du personnel',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importer le menu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favoris',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Articles épuisés',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Codes promo',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galerie',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Ajouter le logo et la couleur principale du restaurant',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Commander des flyers',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Créer une vitrine',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Activer les commandes en direct',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Activer Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Vérifier si le propriétaire / la personne de contact a WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Vérifier que le numéro du restaurant est correct pour recevoir les appels automatiques et ne pas manquer de commandes',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Configurer les horaires du restaurant',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Configurer la localisation du restaurant',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Définissez le type de restaurant et les cuisines affichés sur la vitrine',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Configurer les paramètres de délai de retrait',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Configurer les paramètres de délai de livraison',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Configurer les identifiants du personnel',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importer le menu depuis un fournisseur tiers',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Marquer 4 articles comme favoris. Demander au restaurant quels sont les 4 plats les plus populaires.',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Configurer le comportement des articles épuisés',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Configurer les codes promo',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Mettre à jour la galerie',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Récupérez le logo auprès du restaurant ou sur sa page Lieferando. Enregistrez-le. Choisissez la couleur la plus présente dans le logo.',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Modifier le design du flyer et créer la commande',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Créer la vitrine et modifier le site web si nécessaire',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]:
      'Activer les commandes en direct (« !uniquement à la date de lancement ! »)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Connecter le compte Google Business',
  },
  buttons: {
    mark_as_complete: 'Marquer comme terminé',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
  },
};
